import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyA22cU2YUcKt_eKCDXZ4dWGQ41sWFjc5wQ",
    authDomain: "laptopmarket-aab.firebaseapp.com",
    projectId: "laptopmarket-aab",
    storageBucket: "laptopmarket-aab.firebasestorage.app",
    messagingSenderId: "61234055019",
    appId: "1:61234055019:web:0431c4da7bd4d06c736e2e",
    measurementId: "G-F8DT8066NR"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); 